const types = {
  UPDATE_ADMINISTRATIVE_CARD: '@filter/admnistrativeCard/UPDATE',
  RESET_ADMINISTRATIVE_CARD:
    '@filter/admnistrativeCard/RESET_ADMINISTRATIVE_CARD',
};

export default types;
